export abstract class ILocalStorage {
    public abstract Get(key:string):string;
    public abstract Set(key:string, value:string):void;
    public abstract Remove(key:string):void;
    public abstract Exists(key:string):boolean;
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/infrastructure/privacy-policy/ILocalStorage.ts